import React, { useContext, useEffect, useState, useCallback } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { getCustomerReservations } from '../services/reservationService';
import { Typography, List, ListItem, ListItemText } from '@mui/material';

const CustomerDashboard = () => {
    const { user } = useContext(AuthContext);
    const [reservations, setReservations] = useState([]);

    const fetchReservations = useCallback(async () => {
        try {
            const data = await getCustomerReservations(user.id);
            setReservations(data);
        } catch (error) {
            console.error('Error fetching reservations:', error);
        }
    }, [user]);

    useEffect(() => {
        if (user) {
            fetchReservations();
        }
    }, [user, fetchReservations]);

    return (
        <div>
            <Typography variant="h4">Welcome, {user.name}</Typography>
            <Typography variant="h6">Your Reservations</Typography>
            <List>
                {reservations.map(reservation => (
                    <ListItem key={reservation.id}>
                        <ListItemText
                            primary={`Date: ${reservation.date}, Time: ${reservation.time}, Party Size: ${reservation.party_size}`}
                        />
                    </ListItem>
                ))}
            </List>
        </div>
    );
};

export default CustomerDashboard;